const routes = [
    {
      path: '/refunds',
      name: 'Refunds',
      component: () => import('@/pages/Refunds.vue'),
      meta: {
        pageTitle: 'RefundManagement',
        requiresAuth: true,
        resourceName: 'PAY_SUPPORT',
      },
      children: [
        {
          name: 'CustomersWithTransactionsList',
          path: '',
          component: () => import('./pages/CustomersWithTransactionsList.vue'),
        },
        {
          name: 'SelectedCustomerCartList',
          path: 'customer/:id',
          component: () => import('./pages/SelectedCustomerCartList.vue'),
        }
      ],
    },
  ]
  
  export default routes
  